var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"50px"}},[_c('h1',{staticClass:"h1"},[_vm._v("404")]),_c('p',{staticClass:"p"},[_vm._v("抱歉您当前的页面还在异次元 | "),_c('span',{on:{"click":_vm.rentuMain}},[_vm._v("返回首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }